var map = {
	"./1.png": 3189,
	"./10.png": 9017,
	"./11.png": 8492,
	"./12.png": 2583,
	"./2.png": 6870,
	"./3.png": 4102,
	"./4.png": 1681,
	"./5.png": 4037,
	"./6.png": 6370,
	"./7.png": 2072,
	"./8.png": 2477,
	"./9.png": 3168,
	"./Back.png": 8357,
	"./BigPanada.png": 4188,
	"./Bird.png": 945,
	"./CATTLE-active.png": 4437,
	"./CATTLE.png": 1887,
	"./Camera.png": 3485,
	"./PANDA-active.png": 1549,
	"./PANDA.png": 6195,
	"./banner.png": 14,
	"./contact-banner-mobile.png": 3953,
	"./contact-banner-mobile1.png": 2896,
	"./contact-banner.png": 9291,
	"./down.png": 5035,
	"./icon1.png": 2486,
	"./icon10.png": 5981,
	"./icon11.png": 7363,
	"./icon12.png": 6627,
	"./icon2.png": 9016,
	"./icon3.png": 8234,
	"./icon4.png": 8183,
	"./icon5.png": 250,
	"./icon6.png": 1408,
	"./icon7.png": 4790,
	"./icon8.png": 9830,
	"./icon9.png": 1075,
	"./logo.png": 4427,
	"./textBorder.png": 8877,
	"./tu-arrow-down.png": 3794,
	"./tu-arrow-up.png": 4292,
	"./tu.png": 8932,
	"./up.png": 3242
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;